import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import About from "./components/About";
import Expertise from "./components/Expertise";
import Qualifications from "./components/Qualifications";
import Contributions from "./components/Contributions";
import Blogs from "./components/Blogs";
import Podcasts from "./components/Podcasts";
import FAQs from "./components/FAQs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/toaster";

function App() {
  useEffect(() => {
    // Smooth scroll behavior
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <div className="App">
      <Helmet>
        <title>CA Sanjay Kumar Agrawal | Chartered Accountant | GST, Transfer Pricing & International Tax Expert</title>
        <meta name="description" content="CA Sanjay Kumar Agrawal - Senior Chartered Accountant with 30+ years experience in GST, International Taxation, Transfer Pricing, FEMA advisory and tax litigation. Expert CA services in Gurugram, India." />
        <meta name="keywords" content="CA Sanjay Kumar Agrawal, Chartered Accountant, GST Consultant, Transfer Pricing Expert, International Taxation, FEMA Advisory, Tax Litigation, CA Gurugram, Cost Accountant, Insolvency Professional, Tax Consultant India" />
        <meta name="author" content="CA Sanjay Kumar Agrawal" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="CA Sanjay Kumar Agrawal | Expert Chartered Accountant" />
        <meta property="og:description" content="Senior CA with 30+ years experience in GST, Transfer Pricing, International Tax, and FEMA advisory. Former Chairman ICAI Gurugram Branch." />
        <meta property="og:type" content="website" />
        <meta property="og:image" content="https://cdn.pixabay.com/photo/2021/03/17/04/38/casanjay-6101491_1280.jpg" />
        <meta property="og:url" content="https://www.dsrvindia.com" />
        
        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="CA Sanjay Kumar Agrawal | Chartered Accountant" />
        <meta name="twitter:description" content="Expert CA services in GST, Transfer Pricing, International Taxation with 30+ years experience" />
        <meta name="twitter:image" content="https://cdn.pixabay.com/photo/2021/03/17/04/38/casanjay-6101491_1280.jpg" />
      </Helmet>
      
      <Header />
      <main>
        <Hero />
        <About />
        <Expertise />
        <Qualifications />
        <Contributions />
        <Blogs />
        <Podcasts />
        <FAQs />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

export default App;
